import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import FlipImagesListImagesScreen from "./FlipImagesListImagesScreen";
import MiscFAQ from "../misc_components/MiscFAQ";
import MiscRecommendedPages from "../misc_components/MiscRecommendedPages";

function FlipImagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Image Flipper & Image Rotator Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/flip_image", title: "Batch Image Flipper" },
    data2: { link: "/flip_image", title: "Flip & Rotate Images" },
    data3: { link: "/flip_image", title: "Mirror & Flip Images" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Flip and rotate images online easily. Rotate photos, flip images horizontally or vertically with our fast, secure image flipper and rotator tool."
      ></meta>
      <meta
        name="keywords"
        content="image flipper, image rotator, rotate image, flip image, rotate images online, flip images online, photo rotator, photo flipper, rotate pictures, flip pictures, image rotation tool, image flip tool, rotate image 90 degrees, rotate image 180 degrees, rotate image 360, flip image horizontal, flip image vertical, online image editor, image editing tool, free image rotator, mirror images, mirror image x axis, mirror image y axis, online image flipper, image flipper online, flip images online,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <FlipImagesListImagesScreen title={title}></FlipImagesListImagesScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Image Flipper website offers a fast and user friendly way to flip and rotate images with perfect accuracy and high quality. This powerful tool allows users to flip images horizontally or vertically and rotate photos to the desired orientation in just a few clicks. Whether you need to correct camera orientation, create mirror images, or adjust photos for design and presentation, this platform works efficiently as a reliable image flipper online and image rotator. Supporting popular image formats such as JPG, PNG, and WebP, the tool ensures original image quality is preserved while you flip images or rotate them. With a clean interface and instant processing, users can upload images, preview changes in real time, and download the edited files immediately. Ideal for students, designers, photographers, and content creators, this image flipper helps save time and simplifies image editing tasks. If you are searching for an easy to use bulk image flipper online, a precise bulk image rotator, or a fast way to flip multiple images without complex software, this website delivers an efficient solution for everyday image editing needs." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Flip & Rotate",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Flip Images Tool"
            why_use={[
              {
                title: "Correct Image Orientation",
                description:
                  "Our image flipper helps fix incorrectly oriented photos by flipping images horizontally or vertically. Using an image flipper online or image rotator ensures images display correctly.",
              },
              {
                title: "Fix iOS Image Orientation Issues",
                description:
                  "Our image flipper tool helps fix iOS image orientation problems caused by EXIF rotation errors. Users can flip images to correct sideways or inverted photos from iPhone and iOS devices.",
              },
              {
                title: "Create Mirror and Reflection Effects",
                description:
                  "Flip images to create mirror or reflection effects for creative design, logos, and visual projects using an image flipper online.",
              },
              {
                title: "Fast and Simple Image Editing",
                description:
                  "Our image flipper online allows users to flip images instantly without complex photo editing software, saving time and effort.",
              },
              {
                title: "Useful for Design and Content Creation",
                description:
                  "Designers and content creators use image flipper and image rotator tools to adjust visuals for websites, presentations, and social media.",
              },
              {
                title: "Preserve Original Image Quality",
                description:
                  "High quality image flipper tools maintain resolution and clarity while flipping or rotating images for professional results.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Modern image flipper online tools support JPG, PNG, WebP, and other formats, making it easy to flip images of any type.",
              },
              {
                title: "Improve Image Alignment and Presentation",
                description:
                  "Using an image rotator or image flipper improves alignment, symmetry, and overall visual presentation of photos.",
              },
              {
                title: "Beginner-Friendly and Easy to Use",
                description:
                  "Our image flipper requires no technical or design skills, making it accessible for beginners and everyday users.",
              },
            ]}
          />
          {/* FAQ */}
          <MiscFAQ
            faq_list={[
              {
                title: "How can I flip an image online for free?",
                description:
                  "Visit ShivaPDF.com and open the Flip Images tool. Select the image you want to flip, choose the available flip direction, and process the image. Download the flipped image to your device when it is ready.",
              },
              {
                title: "Can I flip images offline?",
                description:
                  "You can flip images offline when the tool and all required processing resources are available on your device. If the tool needs to load scripts or other resources from the internet, you may need to open it online before using it offline.",
              },
              {
                title: "Can I flip images without uploading them?",
                description:
                  "If ShivaPDF processes images entirely in your browser, you can flip them without uploading the image files to a remote server. This can help protect the privacy of personal photos and confidential images.",
              },
              {
                title: "Is it safe to flip images locally in a browser?",
                description:
                  "Local image processing can help protect privacy because the image does not need to leave your device. Before processing sensitive images, verify that the tool performs the operation locally and does not transmit the files to a server.",
              },
              {
                title: "What is the difference between flipping and rotating an image?",
                description:
                  "Flipping creates a mirror image horizontally or vertically, while rotating turns the image by a specified angle, such as 90, 180, or 270 degrees. Use the flip tool when you want to reverse an image rather than turn it.",
              },
              {
                title: "How do I flip an image horizontally?",
                description:
                  "Horizontal flipping reverses an image from left to right, creating a mirror effect. Open the Flip Images tool on ShivaPDF.com, select your image, choose the horizontal flip option, and save the result.",
              },
              {
                title: "How do I flip an image vertically?",
                description:
                  "Vertical flipping reverses an image from top to bottom. Select your image in the ShivaPDF Flip Images tool, choose the vertical flip option, and download the resulting image.",
              },
              {
                title: "Can I flip an image horizontally and vertically?",
                description:
                  "Yes, if both directions are supported, you can flip an image horizontally, vertically, or apply both transformations. Flipping in both directions is equivalent to rotating the image by 180 degrees.",
              },
              {
                title: "Which image formats can I flip?",
                description:
                  "Supported formats depend on the image tool and your browser. Check the ShivaPDF Flip Images page to confirm whether formats such as JPG, JPEG, PNG, WebP, and other image types are supported.",
              },
              {
                title: "Can I flip a JPG image online?",
                description:
                  "Yes, you can flip a JPG or JPEG image if the format is supported by the tool. Select the image, choose the desired flip direction, and save the transformed result.",
              },
              {
                title: "Can I flip a PNG image without losing transparency?",
                description:
                  "A horizontal or vertical flip does not inherently remove transparency from a PNG image. Transparency preservation depends on the tool's image-processing and export settings, so check the downloaded image if transparent backgrounds are important.",
              },
              {
                title: "Does flipping an image reduce its quality?",
                description:
                  "Flipping changes the arrangement of pixels rather than inherently reducing image quality. The output quality can depend on the export format and compression settings, particularly when saving an image as a lossy format such as JPEG.",
              },
              {
                title: "Can I flip images on my mobile phone?",
                description:
                  "You can access ShivaPDF.com using a supported browser on an iPhone, Android phone, or tablet. Select an image from an available file picker and use the flip options supported by the tool.",
              },
              {
                title: "Can I flip multiple images at once?",
                description:
                  "Batch image flipping is possible only if the tool supports selecting and processing multiple images in one operation. Check the Flip Images page to see whether batch processing is available.",
              },
              {
                title: "Do I need to install software to flip an image?",
                description:
                  "No separate desktop application is needed when using a browser-based image flipping tool. Open ShivaPDF.com in a supported browser and follow the available steps to flip and save your image.",
              },
              {
                title: "Will flipping an image change the original file?",
                description:
                  "The flip operation should produce a transformed result without requiring you to overwrite the original image. Save the output as a separate file if you want to keep the original version unchanged.",
              },
              {
                title: "Can I flip a photo without changing its dimensions?",
                description:
                  "Horizontal and vertical flipping generally preserve the image's width and height. The orientation of the content changes, but the pixel dimensions normally remain the same unless the tool resizes or crops the image.",
              },
              {
                title: "Can I flip images without creating an account?",
                description:
                  "You can use the tool without registering if ShivaPDF does not require an account for this feature. Visit the Flip Images page to check any applicable usage limits or access requirements.",
              },
              {
                title: "Why does my flipped image look blurry?",
                description:
                  "Blurriness may result from resizing, compression, or the export settings used when saving the image. Try preserving the original dimensions and using a suitable output format and quality setting if available.",
              },
              {
                title: "How do I download a flipped image?",
                description:
                  "After flipping your image, use the download option provided by the tool to save the result to your device. Open the downloaded file to confirm that the flip direction, dimensions, and image quality meet your needs.",
              },
              {
                title: "Why should I use ShivaPDF to flip images?",
                description:
                  "ShivaPDF provides browser-based tools for common document and image tasks without requiring separate desktop software. Use the Flip Images tool to create mirrored images for photos, graphics, presentations, and other projects.",
              },
            ]} />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1071677375}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Recommended Tools */}
          <MiscRecommendedPages />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default FlipImagesMain;
